import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hint"];
  static values = { hints: Object };

  // Choosing a DS select option writes only its hidden input, with no event, so it is read back after the interaction.
  sync() {
    requestAnimationFrame(() => {
      const policy = this.element.querySelector("input[name$='[oauth_access_policy]']")?.value;
      if (policy && this.hintsValue[policy]) this.hintTarget.textContent = this.hintsValue[policy];
    });
  }
}
